import React from 'react';

import styled from 'styled-components';



const BlockQuote = ({ block }) => {

  return (
    <Container>
      <blockquote>
        <p>{block.quote}</p>
        <footer>
          {block.citation}
        </footer>
      </blockquote>
    </Container>
  )
};


export default BlockQuote;

const Container = styled.section`
  max-width: ${({ theme }) => theme.content.CONTENT_WIDTH};
  width: 90%;
  display: flex;
  justify-content: center;
  blockquote {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  p {
    color: ${({ theme }) => theme.colors.Primary};
    font-size: 3em;
    text-align: center;
    &:before {
      content:"“";
    }
    &:after {
      content:"”";
    }
  }
  footer {
    color: ${({ theme }) => theme.colors.Primary};
    font-size: 2.4em;
    font-family: 'Bebas Neue', serif;
    margin-top: 1em;
    &:before {
      content:"—";
      margin-right: 0.25em;
    }
  }
  @media all and (min-width: 800px) {
    p {
      font-size: 4em;
    }
    footer {
      font-size: 2.6em;
    }
  }
`;
